import { createColumnHelper } from '@tanstack/react-table'
import React from 'react'
import { Container } from '../../../components/commons'
import Table from '../../../components/Table'
import Pagination from '../../../components/Table/Pagination'
import useUsers, { User } from '../../../services/users.service'
import ModalDelete from '../../../components/Modals/ModalDelete'
import { NamePhoto } from './styles'
import { format, isValid } from 'date-fns'
import SideBarLogs from './SideBarLogs'
import Avatar from '../../../components/Avatar'

export interface UsersProps {}
export type ModalDeleteRef = React.ElementRef<typeof ModalDelete>
type SideBarRef = React.ElementRef<typeof SideBarLogs>

const Logs: React.FunctionComponent<UsersProps> = () => {
  const [page, setPage] = React.useState<number>(1)
  const [search, setSearch] = React.useState('')

  const [sort, setSort] = React.useState<any>()

  const { isLoading, data, refetch } = useUsers(page, 18, search, sort)

  const sideBarLogsRef = React.useRef<SideBarRef>(null)

  const onSearch = (value: string) => {
    setSearch(value)
  }

  const onSortElement = (name: string, sort: string) => {
    setSort({ [name]: sort })
  }

  const columnHelper = createColumnHelper<User>()

  const pageChangeHandler = (page: number) => setPage(page)
  const columns = [
    columnHelper.accessor('name', {
      header: () => 'Nome',
      cell: (info) => {
        return (
          <NamePhoto>
            <Avatar source={info?.row?.original?.photo} />
            {info.getValue()}
          </NamePhoto>
        )
      },
    }),
    columnHelper.accessor('createdAt', {
      header: () => 'Data de criação',
      cell: (info) => {
        try {
          const dateValue = info?.renderValue();
          if (dateValue) {
            const date = new Date(dateValue);
            if (isValid(date)) {
              return format(date, 'dd/MM/yyyy HH:mm');
            }
          }
          return '-';
        } catch (error) {
          console.warn('Erro ao formatar data de log:', error);
          return '-';
        }
      },
    }),
  ]

  return (
    <Container>
      <Table
        title='Logs do sistema'
        onSearch={onSearch}
        isLoading={isLoading}
        onOpenRow={(_id: string) => sideBarLogsRef.current?.openModal(_id)}
        onSort={onSortElement}
        columns={columns}
        data={data?.data}
      />
      <Pagination
        totalPages={data?.totalPages}
        page={page}
        perPage={18}
        pageChangeHandler={pageChangeHandler}
      />

      <SideBarLogs ref={sideBarLogsRef} />
    </Container>
  )
}

export default Logs
